import { useEffect, useState } from 'react';
import { fetchWithToken } from '../../../../utils/helpers/fetcher';
import { createColumnHelper } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';

const useBatchLicenses = () => {
  const navigate = useNavigate();

  const columnHelper = createColumnHelper();
  const pageSize = 10;

  const [batchLicenses, setBatchLicenses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);

  const columns = [
    columnHelper.accessor('name', {
      header: 'Name',
      id: 'name',
      enableSorting: true,
      sortingFn: 'alphanumeric'
    }),
    columnHelper.accessor('codes_amount', {
      header: 'Licenses',
      id: 'codes_amount',
      enableSorting: true,
      sortingFn: 'alphanumeric'
    }),
    columnHelper.accessor('codes_redeemed', {
      header: 'Consumed',
      id: 'codes_redeemed',
      enableSorting: true,
      sortingFn: 'alphanumeric'
    }),
    columnHelper.accessor('created_at', {
      header: 'Start Date',
      id: 'created_at',
      enableSorting: true,
      sortingFn: 'alphanumeric'
    }),
    columnHelper.accessor('expired_at', {
      header: 'Expiry Date',
      id: 'expired_at',
      enableSorting: true,
      sortingFn: 'alphanumeric'
    }),
    columnHelper.accessor('expires_after', {
      header: 'Interval',
      id: 'expires_after',
      enableSorting: true,
      sortingFn: 'alphanumeric'
    })
  ];

  const onClickOnLicense = (e) => {
    navigate(`/licenses/${e.guid}`);
  };

  const getData = async () => {
    setIsLoading(true);
    let response = await fetchWithToken({
      path: `licenses/personals/batches?pageSize=${pageSize}&offset=${offset}`
    });
    setBatchLicenses(response.data.batches);
    setTotal(response.data.total);
    setOffset(response.data.offset);
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return {
    total,
    offset,
    columns,
    batchLicenses,
    pageSize,
    isLoading,
    onClickOnLicense
  };
};
export default useBatchLicenses;
